import * as React from 'react';
import { css } from 'react-strict-dom';

import Text from './Text';

type Props = Readonly<{
  children: React.ReactNode;
}>;

export default function DropdownHeading({ children }: Props) {
  return (
    <Text as="p" style={styles.heading}>
      {children}
    </Text>
  );
}

const styles = css.create({
  heading: {
    fontSize: 12,
    textTransform: 'uppercase',
    color: '#777',
    paddingBlock: 4,
    paddingInline: 16,
  },
});
